import {
  Card, CardContent, Container, Divider, Typography, BottomNavigation, BottomNavigationAction, Paper, Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  DialogActions
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PullToRefresh } from 'react-js-pull-to-refresh';
import { connect } from 'react-redux';
import Page from 'src/components/Page';
import {
  getTasksRequest, resetDefects, resetLabours, resetMaterials
} from '../../store/actions';
import AtananIsler from './AssignedJob';
import Header from './Header';
import { useHistory } from 'react-router';
import BottomRouters from 'src/components/BottomRouters';
import { loadBaslandiJob, removeBaslandiJob } from 'src/utils/storage/StartWorkOrder';
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(1)
  },
  statistics: {
    marginTop: theme.spacing(3)
  },
  AtananIsler: {
    marginTop: theme.spacing(1)
  },
  projects: {
    marginTop: theme.spacing(6)
  },
  todos: {
    marginTop: theme.spacing(6)
  },
  content: {
    padding: 0,
    minHeight: 430,
  },
}));



const Overview = (props) => {
  const classes = useStyles();
  const { t } = useTranslation('overview');
  const [value, setValue] = useState(0);
  const history = useHistory();
  const {
    getTasksRequest, resetDefects, resetLabours, resetMaterials, tasks
  } = props;


  useEffect(() => {
    getTasksRequest();
    resetLabours();
    resetDefects();
    resetMaterials();
    // eslint-disable-next-line
  }, []);

  const AtananIslerData = tasks.tasks;

  const handleRefresh = () => {
    getTasksRequest();
    resetLabours();
    resetDefects();
    resetMaterials();
    removeBaslandiJob();
  };

  const onRefresh = () => new Promise((resolve) => {
    setTimeout(resolve, 150);
    getTasksRequest();
  });

  // useState ve useEffect kullanımı
  const [isPopupDisplayed, setPopupDisplayed] = useState(true);

  useEffect(() => {
    const popUpControl = sessionStorage.getItem('InformationPopup');
    setPopupDisplayed(popUpControl === "1" ? false : true);
  }, []); // boş bağımlılık dizisi, yalnızca ilk render sırasında çalışmasını sağlar

  const handleClose = () => {
    setPopupDisplayed(false);
    sessionStorage.setItem("InformationPopup", "1");
  };

  const baslandiJob = loadBaslandiJob();

  if (baslandiJob?.length > 0) {
    const baslandiJobItem = baslandiJob[0]; // İlk elemanı al
    const jobIndex = AtananIslerData.findIndex(job => job.ReceiptNo === baslandiJobItem.ReceiptNo); // Aynı jobId'ye sahip bir job bul

    if (jobIndex !== -1) {
      // Eğer AtananIslerData içerisinde baslandiJob ile aynı olan bir job varsa, bu job ile swap yap
      AtananIslerData[jobIndex] = baslandiJobItem;
    } else {
      // Eğer aynı jobId bulunmazsa, başlanan jobu AtananIslerData'nın başına ekleyebiliriz.
      AtananIslerData.unshift(baslandiJobItem);
    }
  }



  const openJobs = (AtananIslerData != undefined && AtananIslerData !== '') ? AtananIslerData.filter(f => f.IsOpen === 1) : [];
  return (
    <Page className={classes.root} title={'Sirius Tech'}>
      <Container maxWidth="lg">
        <Header AtananIsler={openJobs} title={t('lblJobScheduleTitle')} />
        <PullToRefresh
          pullDownContent={<CircularProgress status="loading" style={{ marginLeft: '45%' }} />}
          releaseContent={<CircularProgress status="loading" style={{ marginLeft: '45%' }} />}
          refreshContent={<CircularProgress status="loading" style={{ marginLeft: '45%' }} />}
          pullDownThreshold={100}
          onRefresh={onRefresh}
          triggerHeight={500}
          startInvisible
        >

          <div style={{ minHeight: 400, textAlign: 'center' }}>
            <AtananIsler className={classes.AtananIsler} AtananIsler={openJobs} handleRefresh={handleRefresh} />
          </div>
        </PullToRefresh>
        <br />
        <br />
        <br />
        <br />
        <br />
        <BottomRouters />
      </Container>
      <Dialog
        open={isPopupDisplayed}
        fullWidth
        maxWidth="sm"
        onClose={() => handleClose(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {t('lblmportantReminder')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {t('lblInformationText')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
};
export default connect(
  (state) => ({ tasks: state.tasks1 }),
  {
    getTasksRequest, resetDefects, resetLabours, resetMaterials
  }
)(Overview);
